import ApplicationRecord from './ApplicationRecord';

/**
 * Home page.
 *
 *
 */
export default class ErrorPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    Title: 'Error Page, you should not be there.',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,
  }) {}
